import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import {
  Requests,
  RequestUpdateResponse,
  RestrictedActionStatusUpdateRequest,
} from '../models/approvals.model'

const BASE_URL = 'helios-commands'
const ACCOUNT_USERS_BASE_URL = `helios-accounts/set-values/users`

interface CommonProperties {
  createdAt?: string | Date
  actionTimestamp?: string | Date
}

@Injectable({
  providedIn: 'root',
})
export class ApprovalsService {
  constructor(private readonly httpClient: HttpClient) {}

  getRequestsList(): Observable<{ requests: Requests[] }> {
    return this.httpClient
      .get<{ requests: Requests[] }>(`${BASE_URL}/restrictedAction`)
      .pipe(
        map(response => {
          if (!response || !response.requests) {
            return { requests: [] }
          }
          return {
            requests: response.requests.map(request => {
              const createdAt = request.createdAt
                ? new Date(request.createdAt)
                : ''

              const actionTimestamp =
                request.actionTimestamp && request.actionTimestamp != 'Multiple'
                  ? new Date(request.actionTimestamp)
                  : request.actionTimestamp

              return {
                ...request,
                createdAt,
                actionTimestamp,
              }
            }),
          }
        }),
      )
  }

  getUserNames(): Observable<string[]> {
    return this.httpClient.get<string[]>(`${ACCOUNT_USERS_BASE_URL}`)
  }

  getRequestDetailsByType<T extends CommonProperties>(
    requestIds: number[],
    actionType: string,
  ): Observable<{ requests: T[] }> {
    const payload = { requestIds: requestIds }
    return this.httpClient
      .post<{ requests: T[] }>(
        `${BASE_URL}/restrictedAction/request/details/byType/${actionType}`,
        payload,
      )
      .pipe(
        map(response => {
          if (!response || !response.requests) {
            return { requests: [] }
          }
          return {
            requests: response.requests.map((request: CommonProperties) => {
              const createdAt = request.createdAt
                ? new Date(request.createdAt)
                : ''
              const actionTimestamp =
                request.actionTimestamp && request.actionTimestamp != 'Multiple'
                  ? new Date(request.actionTimestamp)
                  : request.actionTimestamp

              return {
                ...request,
                createdAt,
                actionTimestamp,
              } as T
            }),
          }
        }),
      )
  }

  updateRequestDetails(
    request: RestrictedActionStatusUpdateRequest,
  ): Observable<RequestUpdateResponse> {
    return this.httpClient.put<RequestUpdateResponse>(
      `${BASE_URL}/restrictedActionRequest/statusUpdate`,
      request,
    )
  }
}
